




import {Vue, Component} from 'vue-property-decorator'
import {$} from '@/facade'

@Component({})
export default class MiddlewareOAuthGoogle extends Vue {
  async mounted() {
    const param = Object.fromEntries(
      new URLSearchParams(window.location.search)
    )
    const code = param.code
    const state = param.state
    const error = param.error

    if (error || !code || !state) {
      $.toast.error('')
      return
    }

    await this.$auth.signIn({code, state})
  }
}
